import { createContext, useContext } from 'react';
import type { Locale } from '@veylme/shared';

export const LocaleContext = createContext<Locale>('ru');
export const LocaleProvider = LocaleContext.Provider;
export function useLocale(): Locale { return useContext(LocaleContext); }

/** Контекст для сеттера языка — отдельно от значения, чтобы не ребрендить всё дерево. */
export const SetLocaleContext = createContext<(next: Locale) => void>(() => {});
export const SetLocaleProvider = SetLocaleContext.Provider;
export function useSetLocale(): (next: Locale) => void { return useContext(SetLocaleContext); }
